<div class="bg-m1 flex h-full cursor-default flex-col">
  <div class="flex h-2 flex-1 flex-row overflow-y-hidden">
    <div class="mx-6 mb-6 mt-8 flex min-w-[2px] flex-grow flex-col">
      <div class="flex h-11 flex-row items-center justify-between">
        <div class="flex w-full flex-row items-center">
          <div class="flex w-1/4 flex-row items-center">
            <div
              data-cy="modelTitle"
              class="text-s1 flex select-none items-center self-center text-2xl font-semibold"
            >
              {{ pageTitle }}
            </div>

            <div class="flex flex-1 flex-row items-center justify-start">
              <div
                class="ml-10 flex w-[110px] flex-shrink-0 cursor-pointer flex-row items-center justify-center"
                (click)="navToModelsList()"
              >
                <!-- <m-view-list-icon
                [ngClass]="{
                  'text-m500': lastUrl === pathModelsList,
                  'text-s400': lastUrl !== pathModelsList
                }"
              ></m-view-list-icon> -->

                <div
                  class="flex select-none items-center text-lg"
                  [ngClass]="{
                    'text-m500 font-semibold': lastUrl === pathModelsList,
                    'text-s500': lastUrl !== pathModelsList
                  }"
                >
                  Models List
                </div>
              </div>

              <div
                class="ml-6 flex w-[110px] flex-shrink-0 cursor-pointer flex-row items-center justify-center"
                (click)="navToChartsList()"
              >
                <!-- <m-view-list-icon
                  [ngClass]="{
                    'text-m500': lastUrl === pathChartsList,
                    'text-s400': lastUrl !== pathChartsList
                  }"
                ></m-view-list-icon> -->

                <div
                  class="flex select-none items-center text-lg"
                  [ngClass]="{
                    'text-m500 font-semibold': lastUrl === pathChartsList,
                    'text-s500': lastUrl !== pathChartsList
                  }"
                >
                  Charts List
                </div>
              </div>
            </div>

            <!-- <div class="flex flex-1"></div> -->

            <div
              *ngIf="!!model?.modelId"
              [tp]="templateClearQuery"
              [tpIsEnabled]="isExplorer === false || !model?.modelId"
              class="ml-5 h-11 flex-shrink-0"
            >
              <button
                type="button"
                data-cy="chartsClearQueryButton"
                class="border-s400 text-s500 hover:bg-m0 h-11 flex-shrink-0 select-none rounded border px-5 py-2 text-base font-medium focus:outline-none"
                (click)="clearQuery()"
                [disabled]="isExplorer === false"
                >Clear Query</button
              >
            </div>
          </div>

          <ng-template #templateClearQuery>
            <div *ngIf="alias !== restrictedUserAlias && isExplorer === false"
              >Explorer role required</div
            >

            <div
              *ngIf="
                alias !== restrictedUserAlias &&
                isExplorer === true &&
                !model?.modelId
              "
              >Select Model</div
            >
          </ng-template>

          <div
            class="flex h-11 flex-1 flex-row items-center"
            *ngIf="lastUrl !== pathModels && mconfig?.select.length > 0"
          >
            <!-- <div
              *ngIf="!!mconfig && mconfig.warnSelect.length > 0"
              class="text-p500 ml-5 flex h-8 w-8 flex-shrink-0"
              tp="Warning: The selected fields [{{
                mconfig.warnSelect.join(', ')
              }}] may use unsafe aggregations and produce incorrect results"
              placement="left"
            >
              <m-exclamation-icon></m-exclamation-icon>
            </div> -->

            <div class="flex-grow"></div>

            <div class="text-s1 mr-9 flex flex-row items-center text-base">
              <!-- <div *ngIf="isRunningDry === true">Calculating ... </div> -->
              <!-- <div *ngIf="isRunning === true">Running ... </div> -->
              <!-- <div *ngIf="isCanceling === true">Canceling ... </div> -->

              <div *ngIf="!!dryQueryEstimate"
                >Estimate - {{ dryDataSize }} - {{ dryTimeAgo$ | async }}
              </div>

              <m-query-status
                *ngIf="!dryQueryEstimate"
                [query]="query"
                [showDataRowsLength]="true"
                [showLastCompleteDuration]="true"
                [completedWord]="'Completed'"
              ></m-query-status>

              <div
                class="ml-7 flex cursor-pointer flex-row items-center"
                (click)="toggleAutoRun()"
              >
                <ui-switch
                  class="mt-1"
                  [checked]="isAutoRun"
                  color="#64BD63"
                ></ui-switch>

                <div
                  class="text-s1 ml-5 flex h-9 select-none items-center text-base"
                  >Auto Run</div
                >
              </div>

              <ng-template #templateAutoRunSelector>
                <div *ngIf="alias === restrictedUserAlias"
                  >Demo user is restricted</div
                >

                <div
                  *ngIf="alias !== restrictedUserAlias && isAutoRun === false"
                  >Enable Auto Run to use selector</div
                >
              </ng-template>

              <div
                class="ml-5 flex flex-col items-stretch"
                [tp]="templateAutoRunSelector"
                [tpIsEnabled]="
                  alias === restrictedUserAlias || isAutoRun === false
                "
              >
                <div
                  *ngIf="
                    isAutoRun === true &&
                    alias !== restrictedUserAlias &&
                    refreshForm.controls['refresh'].value !== 0
                  "
                  class="h-[6px] w-full"
                ></div>

                <form [formGroup]="refreshForm">
                  <ng-select
                    #refreshSelect
                    [fixNgSelectBottom]="refreshSelect"
                    data-cy="refreshSelect"
                    class="popup-55 w-[100px] select-none"
                    [items]="refreshList"
                    [clearable]="false"
                    [searchable]="false"
                    (change)="refreshChange()"
                    (keyup.esc)="
                      $event.stopImmediatePropagation(); refreshSelect.blur()
                    "
                    (keyup.enter)="
                      $event.stopImmediatePropagation(); refreshSelect.blur()
                    "
                    appendTo="body"
                    bindLabel="label"
                    bindValue="value"
                    formControlName="refresh"
                  >
                    <ng-template ng-label-tmp let-item="item">
                      <div class="ml-1 truncate">{{
                        alias !== restrictedUserAlias ? item.label : ''
                      }}</div>
                    </ng-template>

                    <ng-template ng-option-tmp let-item="item">
                      <div class="ml-1 truncate">{{ item.label }}</div>
                    </ng-template>
                  </ng-select>
                </form>

                <div
                  *ngIf="
                    isAutoRun === true &&
                    alias !== restrictedUserAlias &&
                    refreshForm.controls['refresh'].value !== 0
                  "
                  class="bg-s200 h-[6px] w-full overflow-hidden rounded-full"
                >
                  <div
                    class="bg-g1 h-full transition-all duration-[50ms] ease-linear"
                    [style.width.%]="refreshProgress"
                  >
                  </div>
                </div>
              </div>

              <div
                *ngIf="query?.status !== queryStatusEnum.Running"
                tp="Select Model Fields"
                class="ml-6"
                [tpIsEnabled]="mconfig?.select.length === 0"
              >
                <button
                  type="button"
                  data-cy="modelRunButton"
                  class="text-m0 flex h-12 w-24 select-none items-center justify-center rounded text-base font-medium focus:outline-none"
                  [ngClass]="{
                    'bg-m600': mconfig?.select.length > 0,
                    'cursor-default':
                      mconfig?.select.length === 0 ||
                      isRunButtonPressed === true,
                    'bg-s400': mconfig?.select.length === 0
                  }"
                  (click)="run()"
                  [disabled]="
                    mconfig?.select.length === 0 || isRunButtonPressed === true
                  "
                >
                  <div *ngIf="isRunButtonPressed === false">Run</div>
                  <div
                    *ngIf="isRunButtonPressed === true"
                    class="relative flex h-9 w-9 flex-shrink-0"
                  >
                    <ngx-spinner
                      [name]="modelRunButtonSpinnerName"
                      color="#FFFFFF"
                      bdColor="#00000000"
                      size="default"
                      type="ball-clip-rotate"
                      [fullScreen]="false"
                      [disableAnimation]="true"
                      [zIndex]="10"
                    >
                    </ngx-spinner>
                  </div>
                </button>
              </div>

              <button
                type="button"
                *ngIf="query?.status === queryStatusEnum.Running"
                data-cy="modelCancelButton"
                class="bg-r600 text-m0 ml-6 flex h-12 w-24 items-center justify-center rounded py-2 text-base font-medium focus:outline-none"
                [ngClass]="{
                  'cursor-default': isCancelButtonPressed === true
                }"
                (click)="cancel()"
                [disabled]="isCancelButtonPressed === true"
              >
                <div *ngIf="isCancelButtonPressed === false">Cancel</div>
                <div
                  *ngIf="isCancelButtonPressed === true"
                  class="relative flex h-9 w-9 flex-shrink-0"
                >
                  <ngx-spinner
                    [name]="modelCancelButtonSpinnerName"
                    color="#FFFFFF"
                    bdColor="#00000000"
                    size="default"
                    type="ball-clip-rotate"
                    [fullScreen]="false"
                    [disableAnimation]="true"
                    [zIndex]="10"
                  >
                  </ngx-spinner>
                </div>
              </button>

              <!-- <div class="relative ml-5">
              <m-query-options
                [showRunDryButton]="
                  query?.connectionType === connectionTypeEnum.BigQuery
                "
                (runDryEvent)="runDry()"
              ></m-query-options>
            </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="mt-6 flex h-2 w-full flex-1 flex-row">
        <div
          class="bg-m0 flex h-full w-1/4 flex-shrink-0 flex-col rounded shadow"
        >
          <div
            class="text-s1 flex h-[92px] w-full flex-shrink-0 flex-row items-center pb-6 pt-6"
          >
            <!-- <div
              class="flex h-11 select-none flex-row items-center pl-6 text-lg font-semibold"
            >
              <div class="flex flex-row items-center">
                <div> MODEL </div>
              </div>
            </div> -->

            <div class="ml-6 flex w-2 flex-1 items-center">
              <div class="flex flex-col">
                <div
                  class="text-s500 flex h-9 select-none items-center text-lg font-semibold"
                  >Model</div
                >
              </div>

              <form class="ml-5 w-full flex-1" [formGroup]="modelForm">
                <ng-select
                  #modelsModelSelect
                  [fixNgSelectBottom]="modelsModelSelect"
                  data-cy="modelsModelSelect"
                  class="model-select w-full select-none text-base"
                  [items]="modelSelectItems"
                  [clearable]="false"
                  [searchable]="true"
                  (change)="modelChange()"
                  (keyup.esc)="
                    $event.stopImmediatePropagation(); modelsModelSelect.blur()
                  "
                  (keyup.enter)="
                    $event.stopImmediatePropagation(); modelsModelSelect.blur()
                  "
                  appendTo="body"
                  bindLabel="label"
                  bindValue="modelId"
                  formControlName="model"
                  placeholder="Model"
                >
                  <ng-template ng-label-tmp let-item="item">
                    <div class="ml-1 truncate">
                      <span>{{ item.label }}</span>
                    </div>
                  </ng-template>

                  <ng-template ng-option-tmp let-item="item">
                    <div class="ml-1 truncate">
                      <span>{{ item.label }}</span>
                    </div>
                  </ng-template>
                </ng-select>
              </form>
            </div>

            <div
              (click)="setShowCharts()"
              class="ml-4 flex h-11 cursor-pointer select-none flex-row items-center pl-1 pr-1 text-lg"
            >
              <div class="flex w-[90px] flex-row items-center justify-center">
                <div
                  [ngClass]="{
                    'text-s400': showSchema === true,
                    'font-semibold': showSchema === false
                  }"
                >
                  CHARTS
                </div>
              </div>
            </div>

            <div
              (click)="setShowSchema()"
              class="ml-2 mr-9 flex h-11 cursor-pointer select-none flex-row items-center pl-1 pr-1 text-lg"
            >
              <div class="flex w-[90px] flex-row items-center justify-center">
                <div
                  [ngClass]="{
                    'text-s400': showSchema === false,
                    'font-semibold': showSchema === true
                  }"
                >
                  SCHEMA
                </div>
              </div>
            </div>
          </div>

          <div class="flex flex-1 flex-col" *ngIf="showSchema === true">
            <div
              *ngIf="model?.hasAccess === false"
              class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
              >No access to model</div
            >

            <div
              *ngIf="!!model?.modelId && model?.hasAccess !== false"
              class="divide-s300 ml-6 mr-9 flex flex-col divide-y"
            >
              <div class="flex flex-row"></div>
              <div class="flex flex-row"></div>
            </div>

            <div
              *ngIf="!!model?.modelId && model?.hasAccess !== false"
              class="mb-5 mt-5 flex h-11 flex-row items-center"
            >
              <m-search-icon class="text-s1 ml-8"></m-search-icon>

              <input
                spellcheck="false"
                autocomplete="off"
                data-cy="chartsSearchInput"
                class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[225px] select-none rounded"
                placeholder="Search Fields"
                [ngClass]="{
                  'bg-p200': !!searchSchemaWord
                }"
                [(ngModel)]="searchSchemaWord"
                (ngModelChange)="searchSchemaWordChange()"
              />

              <div
                class="ml-3 h-9 w-9 flex-shrink-0"
                *ngIf="!!searchSchemaWord"
              >
                <m-delete-icon
                  class="text-s1 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  [ngClass]="{
                    'bg-p200 hover:bg-p300 cursor-pointer': !!searchSchemaWord
                  }"
                  (click)="resetSchemaSearch()"
                ></m-delete-icon>
              </div>

              <div class="flex flex-grow"></div>

              <div class="ml-4 mr-11 flex h-9 w-9 flex-shrink-0">
                <button
                  class="text-s1 hover:bg-m200 flex h-9 w-9 flex-shrink-0 cursor-pointer select-none flex-row items-center justify-center rounded"
                  (click)="toggleModelTreeLevels()"
                >
                  <div class="flex h-6 w-6">
                    <m-tree-icon
                      [isFlat]="modelTreeLevels === modelTreeLevelsFlatTime"
                    ></m-tree-icon>
                  </div>
                </button>
              </div>
            </div>

            <div
              *ngIf="model?.hasAccess !== false"
              class="divide-s300 ml-6 mr-9 flex flex-col divide-y"
            >
              <div class="flex flex-row"></div>
              <div class="flex flex-row"></div>
            </div>

            <m-model-tree
              *ngIf="model?.hasAccess !== false"
              class="flex flex-1"
              (expandFilters)="expandFiltersPanel()"
            ></m-model-tree>
          </div>

          <div
            *ngIf="showSchema === false"
            class="divide-s300 ml-6 mr-9 flex flex-col divide-y"
          >
            <div class="flex flex-row"></div>
            <div class="flex flex-row"></div>
          </div>

          <div *ngIf="showSchema === false" class="flex h-2 flex-1 flex-col">
            <div class="mb-5 mt-5 flex h-11 flex-row items-center">
              <m-search-icon class="text-s1 ml-8"></m-search-icon>

              <input
                spellcheck="false"
                autocomplete="off"
                data-cy="chartsSearchInput"
                class="form-input focus:border-m600 border-s400 ml-3 h-10 w-[225px] select-none rounded"
                [placeholder]="'Search Charts'"
                [ngClass]="{
                  'bg-p200': !!searchChartsWord
                }"
                [(ngModel)]="searchChartsWord"
                (ngModelChange)="searchChartsWordChange()"
              />

              <div
                class="ml-3 h-9 w-9 flex-shrink-0"
                *ngIf="!!searchChartsWord"
              >
                <m-delete-icon
                  class="text-s1 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  [ngClass]="{
                    'bg-p200 hover:bg-p300 cursor-pointer': !!searchChartsWord
                  }"
                  (click)="resetChartsSearch()"
                ></m-delete-icon>
              </div>

              <div class="flex flex-grow"></div>

              <button
                *ngIf="
                  showSchema === false &&
                  filteredDraftsLength > 0 &&
                  alias !== restrictedUserAlias
                "
                class="ml-5 mr-10 flex flex-shrink-0 select-none flex-row items-center rounded border px-4 py-2 focus:outline-none"
                [ngClass]="{
                  'border-s400 text-s500 hover:bg-s100':
                    filteredDraftsLength > 0,
                  'border-s300 text-s400 cursor-default':
                    filteredDraftsLength === 0
                }"
                [disabled]="filteredDraftsLength === 0"
                (click)="deleteDrafts()"
              >
                <m-trash-icon></m-trash-icon>
                <div class="ml-3">Drafts</div>
              </button>
            </div>

            <div class="divide-s300 ml-6 mr-9 flex flex-col divide-y">
              <div class="flex flex-row"></div>
              <div class="flex flex-row"></div>
            </div>

            <div
              #leftChartsContainer
              class="flex h-2 flex-grow flex-col overflow-y-auto"
              [ngClass]="{
                visible: isInitialScrollCompleted === true,
                invisible: isInitialScrollCompleted === false
              }"
            >
              <ng-scrollbar
                [orientation]="'vertical'"
                [visibility]="'hover'"
                [appearance]="'compact'"
              >
                <div class="h-[12px]"></div>

                <div
                  *ngIf="
                    filteredDraftsLength > 0 && alias !== restrictedUserAlias
                  "
                >
                  <div
                    *ngFor="
                      let c of filteredCharts | slice: 0 : filteredDraftsLength;
                      let i = index
                    "
                  >
                    <div
                      *ngIf="i === 0"
                      class="text-s500 mb-4 ml-[24px] mr-[36px] mt-4 flex select-none flex-row justify-start font-semibold"
                    >
                      Drafts
                    </div>

                    <ng-container
                      *ngTemplateOutlet="
                        chartsItem;
                        context: {
                          itemI: i,
                          itemChartId: c.chartId,
                          itemModelId: c.modelId,
                          itemTitle: c.title,
                          itemChartType: c.chartType,
                          itemChartUnit: c,
                          itemIsDraft: true
                        }
                      "
                    ></ng-container>
                  </div>
                </div>

                <div
                  *ngIf="
                    filteredDraftsLength > 0 && alias === restrictedUserAlias
                  "
                  class="text-s400 mb-4 ml-[24px] mr-[36px] mt-4 flex select-none flex-row justify-start font-semibold"
                >
                  Drafts are hidden for Demo User</div
                >

                <div
                  class="mb-4 ml-[24px] mr-[36px] mt-4 flex select-none flex-row items-center justify-start"
                >
                  <button
                    class="text-s500 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                    type="button"
                    tp="Fold"
                    (click)="collapseChartsTree()"
                  >
                    <m-folder-minus-icon></m-folder-minus-icon>
                  </button>

                  <div class="text-s500 ml-[12px] font-semibold"
                    >Saved Charts</div
                  >

                  <button
                    class="ml-4 flex h-6 w-6 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                    type="button"
                    (click)="
                      setFavoritesOnly({
                        event: $event,
                        favoritesOnly: !favoritesOnly
                      })
                    "
                    [ngClass]="{
                      'text-m500': favoritesOnly === true,
                      'text-s500': favoritesOnly === false
                    }"
                  >
                    <m-star-icon
                      [isFilled]="favoritesOnly === true"
                    ></m-star-icon>
                  </button>

                  <button
                    tp="by model"
                    type="button"
                    class="ml-5 flex h-6 w-6 flex-shrink-0 cursor-pointer select-none items-center justify-center rounded focus:outline-none"
                    [ngClass]="{
                      'text-m600': chartsByModel === true,
                      'text-s500': chartsByModel === false
                    }"
                    (click)="toggleChartsByModel()"
                  >
                    <m-folder-tree-icon></m-folder-tree-icon>
                  </button>
                </div>

                <div *ngIf="filteredChartNodes?.length > 0" class="ml-6">
                  <tree-root
                    class="h-2 w-full select-none"
                    #chartsTree
                    [nodes]="filteredChartNodes"
                    [options]="treeOptions"
                    (initialized)="treeOnInitialized()"
                    (updateData)="treeOnUpdateData()"
                  >
                    <ng-template #treeNodeTemplate let-node="node">
                      <div
                        *ngIf="node.data.type === 'spaceFolder'"
                        data-cy="chartsTreeItem"
                        class="group/bar flex h-11 w-full select-none flex-row rounded pr-5 hover:cursor-pointer"
                        (click)="chartsTreeNodeOnClick({ node: node })"
                      >
                        <div
                          class="hover:bg-m50 relative flex w-full flex-row items-center rounded pl-2"
                          [style.padding-left.px]="(node.level - 1) * 12"
                        >
                          <div
                            class="ml-2 flex flex-shrink-0 flex-row space-x-1"
                          >
                            <div
                              class="h-6 w-6"
                              *ngIf="node.hasChildren === false"
                            ></div>

                            <m-chevron-right-icon
                              class="text-s500"
                              *ngIf="!node.isExpanded && node.hasChildren"
                            ></m-chevron-right-icon>

                            <m-chevron-down-icon
                              class="text-s500"
                              *ngIf="node.isExpanded && node.hasChildren"
                            ></m-chevron-down-icon>

                            <m-folder-closed-icon
                              class="text-m500"
                              *ngIf="!node.isExpanded || !node.hasChildren"
                            ></m-folder-closed-icon>

                            <m-folder-open-icon
                              class="text-m600"
                              *ngIf="node.isExpanded && node.hasChildren"
                            ></m-folder-open-icon>
                          </div>

                          <div class="ml-3 flex min-w-[2px] flex-1 truncate">
                            <span
                              class="text-s1 truncate text-base"
                              [ngClass]="{
                                'font-semibold':
                                  node.data.isSelectedAncestor === true
                              }"
                              >{{
                                node.data.isSynthetic === true
                                  ? node.data.title
                                  : (node.data.title | capitalize)
                              }}</span
                            >
                          </div>

                          <div
                            class="invisible ml-2 mr-2 flex group-hover/bar:visible"
                          >
                            <m-model-options
                              *ngIf="!!node.data.modelId"
                              [models]="models"
                              [chart]="chart"
                              [treeNode]="node"
                              [isHoverM]="false"
                            ></m-model-options>
                          </div>
                        </div>
                      </div>

                      <div
                        *ngIf="node.data.type === 'spaceUnit'"
                        (click)="chartsTreeNodeOnClick({ node: node })"
                      >
                        <ng-container
                          *ngTemplateOutlet="
                            chartsItem;
                            context: {
                              itemI: null,
                              itemChartId: node.data.unitId,
                              itemModelId: node.data.modelId,
                              itemTitle: node.data.title,
                              itemChartType: node.data.chartType,
                              itemSpaceUnit: node.data,
                              itemIsFavorite: node.data.isFavorite,
                              itemLevel: node.level,
                              itemIsDraft: false
                            }
                          "
                        ></ng-container>
                      </div>
                    </ng-template>
                  </tree-root>
                </div>

                <div
                  *ngIf="filteredChartNodes?.length === 0"
                  class="text-s1 flex select-none justify-center px-6 py-8 text-[17px]"
                >
                  {{
                    !!searchChartsWord
                      ? 'Search results are empty'
                      : favoritesOnly === true
                        ? 'Favorites are empty'
                        : 'Charts are empty'
                  }}
                </div>

                <div class="mb-5"></div>

                <ng-template
                  #chartsItem
                  let-itemI="itemI"
                  let-itemChartId="itemChartId"
                  let-itemModelId="itemModelId"
                  let-itemTitle="itemTitle"
                  let-itemChartType="itemChartType"
                  let-itemChartUnit="itemChartUnit"
                  let-itemSpaceUnit="itemSpaceUnit"
                  let-itemIsFavorite="itemIsFavorite"
                  let-itemLevel="itemLevel"
                  let-itemIsDraft="itemIsDraft"
                >
                  <div
                    [attr.chartId]="itemChartId"
                    class="hover:bg-m50 group mr-5 flex h-11 flex-row items-center rounded pr-2 hover:cursor-pointer"
                    [style.padding-left.px]="
                      itemLevel == null ? null : (itemLevel - 1) * 12
                    "
                    (click)="
                      navToChart({
                        chartId: itemChartId,
                        modelId: itemModelId
                      })
                    "
                    [ngClass]="{
                      'bg-m50': itemChartId === selectedChartId,
                      'ml-5': itemIsDraft === true,
                      'mt-4': itemIsDraft === true && itemI === 0,
                      'mb-5':
                        itemI != null &&
                        ((itemIsDraft === false &&
                          itemI ===
                            (filteredCharts | slice: filteredDraftsLength)
                              .length -
                              1) ||
                          (itemIsDraft === true &&
                            filteredDraftsLength === filteredCharts.length &&
                            itemI === filteredCharts.length - 1))
                    }"
                  >
                    <div class="ml-4 mr-3 flex h-2 items-center">
                      <div
                        *ngIf="itemChartId === selectedChartId"
                        data-cy="chartsSelectedSymbol"
                        class="bg-m600 text-m0 h-9 w-[6px] focus:outline-none"
                      ></div>

                      <div
                        *ngIf="itemChartId !== selectedChartId"
                        class="h-9 w-[6px]"
                      ></div>
                    </div>

                    <div
                      class="ml-1 h-6 w-6 flex-shrink-0"
                      [ngClass]="{
                        'text-m600': itemChartId === selectedChartId,
                        'text-s500': itemChartId !== selectedChartId
                      }"
                    >
                      <!-- <img [src]="c.iconPath" /> -->

                      <m-chart-table-icon
                        *ngIf="itemChartType === chartTypeEnumTable"
                      ></m-chart-table-icon>

                      <m-chart-pivot-table-icon
                        *ngIf="itemChartType === chartTypeEnumPivotTable"
                      ></m-chart-pivot-table-icon>

                      <m-chart-line-icon
                        *ngIf="itemChartType === chartTypeEnumLine"
                      ></m-chart-line-icon>

                      <m-chart-bar-icon
                        *ngIf="itemChartType === chartTypeEnumBar"
                      ></m-chart-bar-icon>

                      <m-chart-scatter-icon
                        *ngIf="itemChartType === chartTypeEnumScatter"
                      ></m-chart-scatter-icon>

                      <m-chart-single-icon
                        *ngIf="itemChartType === chartTypeEnumSingle"
                      ></m-chart-single-icon>

                      <m-chart-pie-icon
                        *ngIf="itemChartType === chartTypeEnumPie"
                      ></m-chart-pie-icon>
                    </div>

                    <div
                      class="ml-3 mt-[2px] select-none truncate"
                      [ngClass]="{
                        'text-m600 font-semibold':
                          itemChartId === selectedChartId,
                        'text-s1': itemChartId !== selectedChartId
                      }"
                    >
                      {{ itemTitle | capitalize }}
                    </div>

                    <div class="flex flex-grow"></div>

                    <button
                      *ngIf="
                        itemIsDraft === false && itemChartId !== emptyChartId
                      "
                      class="ml-2 flex h-8 w-8 flex-shrink-0 items-center justify-center rounded focus:outline-none group-hover:visible"
                      type="button"
                      (click)="
                        toggleFavoriteChart({
                          event: $event,
                          chartId: itemChartId
                        })
                      "
                      [ngClass]="{
                        'text-s300': itemIsFavorite === true,
                        'text-s400': itemIsFavorite !== true
                      }"
                      [class.invisible]="
                        favoritesOnly === true || itemIsFavorite !== true
                      "
                    >
                      <m-star-icon
                        [isFilled]="itemIsFavorite === true"
                      ></m-star-icon>
                    </button>

                    <button
                      *ngIf="
                        chart.draft === true &&
                        itemChartId === chart.chartId &&
                        mconfig?.select.length > 0
                      "
                      data-cy="chartsSaveDraftButton"
                      class="ml-3 flex h-11 items-center justify-center rounded focus:outline-none"
                      (click)="chartSaveAs($event)"
                    >
                      <div
                        class="hover:bg-m200 flex h-9 w-9 flex-shrink-0 flex-row items-center justify-center rounded px-2"
                      >
                        <m-save-icon class="text-s500"></m-save-icon>
                      </div>
                    </button>

                    <button
                      *ngIf="
                        chart.draft === true && itemChartId === chart.chartId
                      "
                      data-cy="chartsDeleteDraftButton"
                      class="hover:bg-m200 text-s500 ml-3 flex h-9 flex-shrink-0 items-center justify-center rounded px-2 focus:outline-none"
                      (click)="deleteDraftChart($event, itemChartUnit)"
                    >
                      <m-trash-icon></m-trash-icon>
                    </button>

                    <div
                      *ngIf="
                        itemIsDraft === false && itemChartId !== emptyChartId
                      "
                      class="invisible ml-2 flex group-hover:visible"
                    >
                      <m-chart-options
                        *ngIf="itemSpaceUnit"
                        [spaceUnit]="itemSpaceUnit"
                        [isHoverM]="false"
                      ></m-chart-options>

                      <m-chart-options
                        *ngIf="itemChartUnit"
                        [chart]="itemChartUnit"
                        [isHoverM]="false"
                      ></m-chart-options>
                    </div>
                  </div>
                </ng-template>
              </ng-scrollbar>
            </div>

            <!-- <div
              class="text-s1 bg-s150 border-s300 flex w-full flex-shrink-0 flex-row items-center border py-5"
            ></div> -->
          </div>
        </div>

        <div
          class="flex h-full flex-1 flex-col"
          *ngIf="
            !(
              lastUrl !== pathModels &&
              lastUrl !== pathChartsList &&
              lastUrl !== pathModelsList
            )
          "
        >
          <div class="ml-6 flex h-full flex-grow">
            <div
              class="ml-6 flex min-w-[2px] flex-grow flex-col"
              *ngIf="
                lastUrl !== pathChartsList &&
                lastUrl !== pathModelsList &&
                lastUrl === pathModels
              "
            >
              <div
                class="text-s1 mb-[80px] flex h-full w-full select-none items-center justify-center text-xl"
              >
                Select Chart
              </div>
            </div>

            <div
              class="h-full w-full"
              *ngIf="lastUrl === pathChartsList || lastUrl === pathModelsList"
            >
              <router-outlet></router-outlet>
            </div>
          </div>
        </div>

        <div
          class="ml-6 flex min-h-0 min-w-[2px] flex-grow flex-col space-y-2"
          *ngIf="
            lastUrl !== pathModels &&
            lastUrl !== pathChartsList &&
            lastUrl !== pathModelsList
          "
        >
          <div
            class="bg-m0 min-h-0 w-full rounded shadow"
            [ngClass]="{
              'h-[45%] flex-shrink-0':
                chartIsExpanded === true && dataIsExpanded === true,
              'flex-1': chartIsExpanded === true && dataIsExpanded === false,
              'flex-shrink-0': chartIsExpanded === false
            }"
          >
            <div class="flex h-full flex-col">
              <div
                class="bg-m0 flex h-[92px] flex-shrink-0 flex-row items-center pb-6 pr-5 pt-6"
              >
                <m-panel-title
                  [title]="'Chart'"
                  [isExpanded]="chartIsExpanded"
                  (toggleEvent)="toggleChartPanel()"
                  [showToggle]="true"
                ></m-panel-title>

                <ng-template #templateChartSaveAs>
                  <div *ngIf="canAccessChartModel === false"
                    >Read-only chart</div
                  >

                  <div
                    *ngIf="
                      canAccessChartModel !== false &&
                      (isSelectValid === false ||
                        mconfig?.chart?.isValid === false ||
                        chartTitleForm?.valid === false)
                    "
                    >Chart is not valid</div
                  >

                  <div
                    *ngIf="
                      canAccessChartModel !== false &&
                      isSelectValid === true &&
                      mconfig?.chart?.isValid === true &&
                      chartTitleForm?.valid === true &&
                      alias === restrictedUserAlias
                    "
                    >Demo user is restricted</div
                  >
                </ng-template>

                <div
                  *ngIf="mconfig?.select.length > 0"
                  class="ml-5"
                  [tp]="templateChartSaveAs"
                  [tpIsEnabled]="
                    canAccessChartModel === false ||
                    isSelectValid === false ||
                    mconfig?.chart?.isValid === false ||
                    chartTitleForm?.valid === false ||
                    alias === restrictedUserAlias
                  "
                >
                  <button
                    type="button"
                    data-cy="chartSaveAsButton"
                    class="w-28 flex-shrink-0 select-none rounded border py-2 text-base font-medium focus:outline-none"
                    [ngClass]="{
                      'border-s300 text-s400 cursor-default':
                        canAccessChartModel === false ||
                        isSelectValid === false ||
                        mconfig.chart.isValid === false ||
                        chartTitleForm.valid === false ||
                        alias === restrictedUserAlias,
                      'border-s400 text-s500 hover:bg-s100':
                        isSelectValid === true &&
                        canAccessChartModel !== false &&
                        mconfig.chart.isValid === true &&
                        chartTitleForm.valid === true &&
                        alias !== restrictedUserAlias &&
                        chart.draft === false,
                      'border-m600 text-m600':
                        isSelectValid === true &&
                        canAccessChartModel !== false &&
                        mconfig.chart.isValid === true &&
                        chartTitleForm.valid === true &&
                        alias !== restrictedUserAlias &&
                        chart.draft === true
                    }"
                    (click)="chartSaveAs($event)"
                    [disabled]="
                      canAccessChartModel === false ||
                      isSelectValid === false ||
                      mconfig.chart.isValid === false ||
                      chartTitleForm.valid === false ||
                      alias === restrictedUserAlias
                    "
                    >Save As</button
                  >
                </div>

                <button
                  *ngIf="mconfig?.select.length > 0"
                  data-cy="modelShowChartButton"
                  class="text-s500 hover:bg-m200 ml-5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded focus:outline-none"
                  (click)="showChart($event)"
                >
                  <m-chart-zoom-icon></m-chart-zoom-icon>
                </button>

                <div
                  *ngIf="mconfig?.select.length > 0"
                  class="text-s1 ml-10 select-none text-base"
                  >Title</div
                >

                <div
                  *ngIf="mconfig?.select.length > 0"
                  [formGroup]="chartTitleForm"
                  class="ml-5 mr-5 flex w-full flex-col items-start"
                  tp="Read-only chart"
                  tpPlacement="top-start"
                  [tpIsEnabled]="canAccessChartModel === false"
                >
                  <div class="h-6"></div>
                  <input
                    autocomplete="off"
                    spellcheck="false"
                    data-cy="modelChartTitleInput"
                    class="form-input border-s3 focus:border-m600 text-s500 h-10 w-full select-none rounded font-semibold disabled:cursor-default disabled:bg-gray-100 disabled:opacity-100"
                    [ngClass]="{
                      'border-r600':
                        chartTitleForm.controls['chartTitle'].invalid &&
                        chartTitleForm.controls['chartTitle'].touched
                    }"
                    formControlName="chartTitle"
                    placeholder="Title"
                    (blur)="chartTitleBlur()"
                  />
                  <m-validation
                    [control]="chartTitleForm.controls['chartTitle']"
                  ></m-validation>
                </div>

                <div
                  *ngIf="mconfig?.select.length > 0"
                  class="w-1/3 flex-shrink-0 pr-4"
                >
                  <div class="flex flex-row items-center justify-end space-x-5">
                    <ng-container *ngIf="canAccessChartModel === true">
                      <m-chart-table-icon
                        class="h-6 w-6 cursor-pointer"
                        [ngClass]="{
                          'text-m500':
                            mconfig.chart?.type === chartTypeEnumTable,
                          'text-s500':
                            mconfig.chart?.type !== chartTypeEnumTable
                        }"
                        (click)="chartTypeChange(chartTypeEnumTable)"
                      ></m-chart-table-icon>

                      <m-chart-pivot-table-icon
                        class="h-6 w-6 cursor-pointer"
                        [ngClass]="{
                          'text-m500':
                            mconfig.chart?.type === chartTypeEnumPivotTable,
                          'text-s500':
                            mconfig.chart?.type !== chartTypeEnumPivotTable
                        }"
                        (click)="chartTypeChange(chartTypeEnumPivotTable)"
                      ></m-chart-pivot-table-icon>

                      <m-chart-line-icon
                        class="h-6 w-6 cursor-pointer"
                        [ngClass]="{
                          'text-m500':
                            mconfig.chart?.type === chartTypeEnumLine,
                          'text-s500': mconfig.chart?.type !== chartTypeEnumLine
                        }"
                        (click)="chartTypeChange(chartTypeEnumLine)"
                      ></m-chart-line-icon>

                      <m-chart-bar-icon
                        class="h-6 w-6 cursor-pointer"
                        [ngClass]="{
                          'text-m500': mconfig.chart?.type === chartTypeEnumBar,
                          'text-s500': mconfig.chart?.type !== chartTypeEnumBar
                        }"
                        (click)="chartTypeChange(chartTypeEnumBar)"
                      ></m-chart-bar-icon>

                      <m-chart-scatter-icon
                        class="h-6 w-6 cursor-pointer"
                        [ngClass]="{
                          'text-m500':
                            mconfig.chart?.type === chartTypeEnumScatter,
                          'text-s500':
                            mconfig.chart?.type !== chartTypeEnumScatter
                        }"
                        (click)="chartTypeChange(chartTypeEnumScatter)"
                      ></m-chart-scatter-icon>

                      <m-chart-single-icon
                        class="h-6 w-6 cursor-pointer"
                        [ngClass]="{
                          'text-m500':
                            mconfig.chart?.type === chartTypeEnumSingle,
                          'text-s500':
                            mconfig.chart?.type !== chartTypeEnumSingle
                        }"
                        (click)="chartTypeChange(chartTypeEnumSingle)"
                      ></m-chart-single-icon>

                      <m-chart-pie-icon
                        class="h-6 w-6 cursor-pointer"
                        [ngClass]="{
                          'text-m500': mconfig.chart?.type === chartTypeEnumPie,
                          'text-s500': mconfig.chart?.type !== chartTypeEnumPie
                        }"
                        (click)="chartTypeChange(chartTypeEnumPie)"
                      ></m-chart-pie-icon>
                    </ng-container>

                    <div
                      class="ml-5"
                      tp="Read-only chart"
                      [tpIsEnabled]="canAccessChartModel === false"
                    >
                      <form
                        [formGroup]="chartTypeForm"
                        *ngIf="mconfig?.select.length > 0"
                        [ngClass]="{
                          'pointer-events-none': canAccessChartModel === false
                        }"
                      >
                        <ng-select
                          #chartTypeSelect
                          [fixNgSelectBottom]="chartTypeSelect"
                          data-cy="mainChartTypeSelect"
                          class="main-chart-type-select w-[220px] select-none text-base focus:outline-none"
                          [items]="chartTypesList"
                          [clearable]="false"
                          [searchable]="false"
                          (change)="chartTypeChange()"
                          (keyup.esc)="
                            $event.stopImmediatePropagation();
                            chartTypeSelect.blur()
                          "
                          (keyup.enter)="
                            $event.stopImmediatePropagation();
                            chartTypeSelect.blur()
                          "
                          appendTo="body"
                          bindLabel="label"
                          bindValue="value"
                          formControlName="chartType"
                        >
                          <ng-template ng-label-tmp let-item="item">
                            <div
                              class="ml-1 flex flex-row items-center justify-start space-x-3"
                            >
                              <img
                                class="mb-[2px] h-6 w-6"
                                [src]="item.iconPath"
                              />
                              <div> {{ item.label }} </div>
                            </div>
                          </ng-template>

                          <ng-template ng-option-tmp let-item="item">
                            <div
                              class="ml-1 flex flex-row items-center justify-start space-x-3"
                            >
                              <img
                                class="mb-[2px] h-6 w-6"
                                [src]="item.iconPath"
                              />
                              <div> {{ item.label }} </div>
                            </div>
                          </ng-template>
                        </ng-select>
                      </form>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="divide-s300 ml-6 mr-5 flex flex-col divide-y"
                *ngIf="chartIsExpanded"
              >
                <div class="flex flex-row"></div>
                <div class="flex flex-row"></div>
              </div>

              <div
                class="mx-5 mb-5 mt-5 flex h-2 flex-grow"
                *ngIf="chartIsExpanded"
              >
                <div
                  *ngIf="mconfig?.select.length === 0"
                  class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
                  >Select Model Fields</div
                >

                <div
                  *ngIf="mconfig?.select.length > 0"
                  class="flex h-full w-2 flex-1 flex-row items-start justify-center space-x-5"
                >
                  <div class="h-full w-full overflow-auto pb-3">
                    <div
                      class="h-full w-full"
                      [ngClass]="{
                        'max-w-max':
                          (mconfig?.chart.type === chartTypeEnumTable ||
                            mconfig?.chart.type === chartTypeEnumPivotTable) &&
                          isSelectValid === true &&
                          mconfig?.chart.isValid === true &&
                          qData?.length > 0
                      }"
                    >
                      <m-chart-view
                        *ngIf="mconfig?.chart"
                        class="h-full w-full"
                        [modelType]="mconfig.modelType"
                        [mconfigFields]="mconfig.fields"
                        [mconfigTimezone]="mconfig.timezone"
                        [isTableHeaderWide]="true"
                        [qData]="qData"
                        [chart]="mconfig.chart"
                        [isAnimation]="true"
                        [isStoreModel]="mconfig.modelType === modelTypeStore"
                        [queryStatus]="query.status"
                        [chartInstanceId]="'model-chart'"
                        (chartPartChange)="
                          updateChartPart({ chartPart: $event })
                        "
                      ></m-chart-view>
                    </div>
                  </div>

                  <div
                    class="flex h-full w-1/3 flex-shrink-0 flex-col overflow-y-auto border-l"
                    [ngClass]="{
                      'border-s300': mconfig.chart.isValid === true,
                      'border-r600': mconfig.chart.isValid === false
                    }"
                  >
                    <div
                      *ngIf="canAccessChartModel === false"
                      class="text-s500 flex h-full select-none items-center justify-center text-center text-[17px]"
                      >Read-only chart</div
                    >

                    <ng-scrollbar
                      *ngIf="canAccessChartModel === true"
                      [orientation]="'vertical'"
                      [visibility]="'hover'"
                      [appearance]="'compact'"
                    >
                      <m-chart-editor
                        [chart]="mconfig.chart"
                        [isReport]="false"
                        [canAccessModel]="canAccessChartModel"
                        [mconfigFields]="mconfig.fields"
                        [queryId]="mconfig?.queryId"
                      ></m-chart-editor>
                    </ng-scrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="w-full flex-shrink-0">
            <div class="flex flex-col">
              <div class="mr-5 flex flex-shrink-0 flex-grow flex-row">
                <div
                  class="mt-4 flex min-h-[76px] flex-shrink-0 flex-grow flex-row"
                >
                  <div
                    (click)="toggleFiltersPanel()"
                    class="text-s1 mt-1 flex h-11 select-none flex-row items-start space-x-2 px-5 py-3 text-xl font-semibold"
                    [ngClass]="{
                      'cursor-pointer':
                        canAccessChartModel !== false &&
                        mconfig?.extendedFilters.length > 0,
                      'cursor-default':
                        canAccessChartModel === false ||
                        mconfig?.extendedFilters.length === 0
                    }"
                  >
                    <div class="flex flex-row items-center space-x-2">
                      <m-chevron-right-icon
                        *ngIf="
                          !filtersIsExpanded &&
                          canAccessChartModel !== false &&
                          mconfig?.extendedFilters.length > 0
                        "
                      ></m-chevron-right-icon>

                      <m-chevron-down-icon
                        *ngIf="
                          filtersIsExpanded &&
                          canAccessChartModel !== false &&
                          mconfig?.extendedFilters.length > 0
                        "
                      ></m-chevron-down-icon>

                      <div
                        class="h-6 w-6"
                        *ngIf="mconfig?.extendedFilters.length === 0"
                      ></div>

                      <div> Parameters </div>
                    </div>
                  </div>

                  <div class="flex w-full flex-col">
                    <div class="flex w-full flex-row">
                      <button
                        *ngIf="
                          mconfig?.select.length > 0 &&
                          canAccessChartModel !== false &&
                          (filtersIsExpanded === true ||
                            mconfig?.extendedFilters.length === 0)
                        "
                        type="button"
                        data-cy="chartsAddParameterButton"
                        class="border-s400 text-s500 hover:bg-m0 ml-2 mt-2 h-11 flex-shrink-0 select-none rounded border px-4 py-2 focus:outline-none"
                        (click)="addParameter()"
                      >
                        Add Filter
                      </button>

                      <div class="min-h-[68px]"></div>

                      <div
                        class="w-2 flex-1"
                        [ngClass]="{
                          'ml-7': filtersIsExpanded === true
                        }"
                      >
                        <div
                          class="flex flex-row items-start"
                          *ngIf="
                            !filtersIsExpanded &&
                            canAccessChartModel !== false &&
                            mconfig?.extendedFilters.length > 0
                          "
                        >
                          <m-bricks
                            class="mb-5 ml-3 mr-5 mt-3 flex max-h-[150px] max-w-max cursor-pointer flex-row items-start justify-start overflow-auto"
                            [extendedFilters]="mconfig.extendedFilters"
                            [isKeepBackgroundColor]="false"
                            (click)="toggleFiltersPanel()"
                          ></m-bricks>
                        </div>

                        <div
                          class="max-h-[260px] w-full overflow-auto"
                          *ngIf="
                            filtersIsExpanded && canAccessChartModel !== false
                          "
                        >
                          <m-model-filters
                            [storeContent]="model.storeContent"
                          ></m-model-filters>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            class="bg-m0 w-full rounded shadow"
            [ngClass]="{
              'min-h-0 flex-1': dataIsExpanded === true,
              'h-[84px] flex-shrink-0': dataIsExpanded === false
            }"
          >
            <div class="flex h-full flex-col">
              <div
                class="bg-m0 flex h-[84px] flex-shrink-0 flex-row items-center"
              >
                <div class="flex flex-1 flex-row items-center">
                  <m-panel-title
                    class="mb-1"
                    [title]="'Data'"
                    [isExpanded]="dataIsExpanded"
                    (toggleEvent)="toggleDataPanel()"
                    [showToggle]="true"
                  ></m-panel-title>

                  <div
                    *ngIf="mconfig?.select.length > 0"
                    class="ml-5 flex cursor-pointer flex-row items-center"
                    (click)="toggleFormat()"
                  >
                    <div
                      class="text-s1 flex h-9 select-none items-center text-base"
                      >Format</div
                    >

                    <ui-switch
                      class="ml-5 mt-1"
                      [checked]="isFormat"
                    ></ui-switch>
                  </div>

                  <div
                    class="text-s1 ml-10 select-none text-base"
                    *ngIf="mconfig?.select.length > 0"
                    >Limit</div
                  >

                  <div
                    [formGroup]="limitForm"
                    *ngIf="mconfig?.select.length > 0"
                    class="ml-5 flex flex-col items-start"
                    tp="Read-only chart"
                    [tpIsEnabled]="canAccessChartModel === false"
                  >
                    <div class="h-6"></div>
                    <input
                      autocomplete="off"
                      spellcheck="false"
                      data-cy="modelLimitInput"
                      class="form-input border-s3 focus:border-m600 h-[36px] w-32 rounded disabled:cursor-default disabled:bg-gray-100 disabled:opacity-100"
                      [ngClass]="{
                        'border-r600':
                          limitForm.controls['limit'].invalid &&
                          limitForm.controls['limit'].touched
                      }"
                      formControlName="limit"
                      (blur)="limitBlur()"
                    />
                    <m-validation
                      [control]="limitForm.controls['limit']"
                    ></m-validation>
                  </div>

                  <div
                    class="text-s1 ml-5 select-none text-base"
                    *ngIf="mconfig?.select.length > 0"
                    >Timezone</div
                  >

                  <div
                    class="ml-5 mr-9 flex w-2 flex-1"
                    *ngIf="mconfig?.select.length > 0"
                  >
                    <form
                      class="w-full"
                      [formGroup]="timezoneForm"
                      tp="Timezone change is not allowed"
                      [tpIsEnabled]="
                        timezoneForm.controls['timezone'].disabled === true
                      "
                    >
                      <ng-select
                        #modelTimezoneSelect
                        [fixNgSelectBottom]="modelTimezoneSelect"
                        data-cy="modelTimezoneSelect"
                        class="w-full select-none text-base"
                        [items]="timezones"
                        [clearable]="false"
                        [searchable]="true"
                        [searchFn]="timezoneSearchFn"
                        (change)="timezoneChange()"
                        (keyup.esc)="
                          $event.stopImmediatePropagation();
                          modelTimezoneSelect.blur()
                        "
                        (keyup.enter)="
                          $event.stopImmediatePropagation();
                          modelTimezoneSelect.blur()
                        "
                        appendTo="body"
                        bindLabel="label"
                        bindValue="value"
                        formControlName="timezone"
                      >
                        <ng-template ng-label-tmp let-item="item">
                          <div class="truncate">{{ item.label }}</div>
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item">
                          <div class="truncate">{{ item.label }}</div>
                        </ng-template>
                      </ng-select>
                    </form>
                  </div>
                </div>

                <div
                  class="text-s1 flex flex-1 flex-row items-center"
                  *ngIf="mconfig?.select.length > 0"
                >
                  <div
                    (click)="toggleInfoPanel()"
                    class="flex h-11 cursor-pointer select-none flex-row items-center pl-2 pr-5 text-xl font-semibold"
                  >
                    <div class="flex flex-row items-center space-x-2">
                      <m-chevron-right-icon
                        *ngIf="!rightIsShow"
                      ></m-chevron-right-icon>
                      <m-chevron-down-icon
                        *ngIf="rightIsShow"
                      ></m-chevron-down-icon>

                      <div> Query </div>
                    </div>
                  </div>

                  <div
                    (click)="setShowYamlTile()"
                    class="ml-5 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[50px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.YamlTile,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.YamlTile
                        }"
                      >
                        TILE
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="model.type === modelTypeMalloy"
                    (click)="setShowJsonAppliedGivens()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[75px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.JsonAppliedGivens,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.JsonAppliedGivens
                        }"
                      >
                        GIVENS
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="model.type === modelTypeStore"
                    (click)="setShowJsonStoreRequestParts()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[100px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.JsonStoreRequestParts,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.JsonStoreRequestParts
                        }"
                      >
                        REQUEST
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="model.type === modelTypeStore"
                    (click)="setShowJavascriptStoreRequestFunction()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[35px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.JavascriptStoreRequestFunction,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.JavascriptStoreRequestFunction
                        }"
                      >
                        JS
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="model.type === modelTypeMalloy"
                    (click)="setShowMalloyQuery()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[88px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.MalloyQuery,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.MalloyQuery
                        }"
                      >
                        MALLOY
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="model.type === modelTypeMalloy"
                    (click)="setShowSqlMalloy()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[50px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.SqlMalloy,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.SqlMalloy
                        }"
                      >
                        SQL
                      </div>
                    </div>
                  </div>

                  <div
                    (click)="setShowJsonResults()"
                    class="ml-5 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[60px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.JsonResults,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.JsonResults
                        }"
                      >
                        JSON
                      </div>
                    </div>
                  </div>

                  <!-- <div
                    *ngIf="model.type === modelTypeMalloy"
                    (click)="setShowMalloyCompiledQuery()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[115px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.MalloyCompiledQuery,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.MalloyCompiledQuery
                        }"
                      >
                        METADATA
                      </div>
                    </div>
                  </div> -->

                  <div
                    *ngIf="model.type === modelTypeMalloy"
                    (click)="setShowMalloySource()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[88px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.MalloySource,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.MalloySource
                        }"
                      >
                        SOURCE
                      </div>
                    </div>
                  </div>

                  <div
                    *ngIf="model.type === modelTypeStore"
                    (click)="setShowYamlStore()"
                    class="ml-3 flex h-11 cursor-pointer select-none flex-row items-center text-lg"
                  >
                    <div
                      class="flex w-[75px] flex-row items-center justify-center"
                    >
                      <div
                        [ngClass]="{
                          'text-s400':
                            rightIsShow === false ||
                            queryPartForm.controls['queryPart'].value !==
                              queryPartEnum.YamlStore,
                          'font-semibold':
                            rightIsShow &&
                            queryPartForm.controls['queryPart'].value ===
                              queryPartEnum.YamlStore
                        }"
                      >
                        STORE
                      </div>
                    </div>
                  </div>

                  <div
                    class="ml-5 select-none"
                    *ngIf="
                      rightIsShow === true &&
                      mconfig?.select.length > 0 &&
                      [
                        queryPartEnum.YamlModel,
                        queryPartEnum.YamlStore,
                        queryPartEnum.MalloySource
                      ].indexOf(queryPartForm.controls['queryPart'].value) > -1
                    "
                  >
                    <button
                      class="text-m600 flex flex-shrink-0 flex-row items-center focus:outline-none"
                      (click)="goToEditFile()"
                    >
                      <m-arrow-narrow-right-icon></m-arrow-narrow-right-icon>

                      <div class="ml-2 text-lg">File</div>
                    </button>
                  </div>

                  <div class="flex flex-1"></div>

                  <!-- <button
                    (click)="toggleChartPanel()"
                    class="text-s1 focus-none hover:bg-m200 ml-5 mr-9 flex h-9 w-9 items-center justify-center rounded"
                  >
                    <m-unfold-more-icon
                      *ngIf="chartIsExpanded === true"
                    ></m-unfold-more-icon>

                    <m-unfold-less-icon
                      *ngIf="chartIsExpanded === false"
                    ></m-unfold-less-icon>
                  </button> -->
                </div>
              </div>

              <div
                *ngIf="dataIsExpanded"
                class="divide-s300 mx-5 flex flex-col divide-y"
              >
                <div class="flex flex-row"></div>
                <div class="flex flex-row"></div>
              </div>

              <div
                *ngIf="dataIsExpanded"
                class="mx-5 mb-0 mt-0 flex h-2 flex-grow"
              >
                <!-- <div
                  *ngIf="mconfig?.select.length === 0"
                  class="text-s1 flex h-full w-full select-none items-center justify-center text-xl"
                  >Select Model Fields</div
                > -->

                <div
                  class="flex h-full w-full flex-row items-start justify-center"
                >
                  <div class="flex h-full w-2 flex-1 flex-row items-start">
                    <m-main-table
                      class="block h-full min-w-0 max-w-full flex-shrink [width:fit-content]"
                      [isTableHeaderWide]="true"
                      *ngIf="mconfig?.select.length > 0"
                      [isEdit]="true"
                      [canAccessModel]="canAccessChartModel"
                      [isFormat]="isFormat"
                      [mconfig]="mconfig"
                      [qData]="qData"
                      [mconfigFields]="mconfig.fields"
                      [modelFields]="model.fields"
                    ></m-main-table>

                    <div class="flex h-2 w-2 flex-shrink-0"></div>

                    <div
                      [ngClass]="{
                        'ml-8': mconfig?.select.length === 0,
                        'ml-3': mconfig?.select.length > 0
                      }"
                      class="mt-[64px] flex flex-shrink-0"
                      tp="Read-only chart"
                      [tpIsEnabled]="canAccessChartModel === false"
                    >
                      <button
                        type="button"
                        data-cy="chartsAddColumnButton"
                        class="border-s400 text-s500 hover:bg-s100 disabled:border-s300 disabled:text-s400 flex select-none rounded border px-1 py-1 focus:outline-none disabled:cursor-default disabled:bg-gray-100 disabled:hover:bg-gray-100"
                        [disabled]="canAccessChartModel === false"
                        (click)="addColumn()"
                      >
                        <m-add-icon></m-add-icon>
                      </button>
                    </div>

                    <div class="flex h-2 w-[24px] flex-shrink-0"></div>
                  </div>

                  <div
                    *ngIf="mconfig?.select.length > 0 && rightIsShow === true"
                    class="border-s300 h-full w-2 flex-1"
                  >
                    <m-query-info-viewer
                      [queryPart]="queryPartForm.controls['queryPart'].value"
                      [modelFileText]="model.fileText"
                    ></m-query-info-viewer>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="routerEvents$ | async"></div>
<div *ngIf="nav$ | async"></div>
<div *ngIf="modelTreeLevels$ | async"></div>
<div *ngIf="chartsByModel$ | async"></div>
<div *ngIf="showSchema$ | async"></div>
<div *ngIf="isAutoRun$ | async"></div>
<div *ngIf="isExplorer$ | async"></div>
<div *ngIf="charts$ | async"></div>
<div *ngIf="model$ | async"></div>
<div *ngIf="chart$ | async"></div>
<div *ngIf="struct$ | async"></div>
<div *ngIf="alias$ | async"></div>
